var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWishIconProduct = function SvgWishIconProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    d: "M16.315 2.203c1.391-.282 2.992-.024 4.644 1.284 1.107.926 2.181 2.633 2.14 4.877-.042 2.237-1.197 5.174-4.885 8.532l-.013.011-.012.012a51 51 0 0 1-3.383 2.996 26 26 0 0 1-1.835 1.368c-.414.274-.74.456-.971.56a7 7 0 0 1-.97-.56 26 26 0 0 1-1.836-1.368 51 51 0 0 1-3.383-2.996l-.012-.012-.013-.01-.338-.315C2.028 13.355.941 10.532.901 8.364.86 6.118 1.937 4.409 3.045 3.484 4.63 2.184 6.227 1.92 7.64 2.203c1.445.29 2.759 1.17 3.672 2.252l.688.814.688-.815c.916-1.087 2.201-1.962 3.627-2.251Z"
  })));
};
export default SvgWishIconProduct;